import assetUrl from './utils/assetUrl';

export const PAYMENT_SESSION_ID_LENGTH = 36;

export const MONTHS = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

export const COUNTRY_CODES = {
    USA: 'us'
};

const cardsDir = assetUrl('images/cards/Cards.svg');

export const CARD_LOGOS = {
    maestro: `${cardsDir}#Maestro`,
    'maestro (international)': `${cardsDir}#Maestro`,
    mastercard: `${cardsDir}#Mastercard`,
    visa: `${cardsDir}#Visa`,
    visaElectron: `${cardsDir}#Visa`,
    discover: `${cardsDir}#Discover`,
    optileOther: `${cardsDir}#Other`,
    cybersourceOther: assetUrl('images/card-number.svg')
};

export const CARD_TYPES = {
    debit: 'debit',
    credit: 'credit'
};

export const CREATE_TOKEN_CAPTURE_CONTEXT_USED_TOO_MANY_TIMES = 'CREATE_TOKEN_CAPTURE_CONTEXT_USED_TOO_MANY_TIMES';

export const IMAGES_PATHS = {
    CLOSE: assetUrl('images/close-lilac.png'),
    CREDIT_CARD_ADD: assetUrl('images/add-credit-card.svg'),
    CREDIT_CARD_ADD_RELAUNCH: assetUrl('images/add-credit-card-relaunch.svg')
};

export const NEW_CYBERSOURCE_PAYMENT_FORM = 'new-cybersource-payment-form';
export const ZEPZ_PAYMENT_FORM = 'zepz-payment-form';

export const CARDINAL_ACTIONS_FAILED_CODES = [
    'FAILURE',
    'ERROR'
];

export const GENERIC_ERROR_TYPES = {
    standard: 'standard',
    session: 'session'
};

export const HTTP_STATUS = {
    NOT_FOUND: 404,
    SOMETHING_WENT_WRONG: 500
};

export const PAYMENT_STATUS_RECHECK_FREQUENCY = 1500;
export const PAYMENT_AUTH_RETRY_DELAY = 5000;


export const PAYMENT_STATUS = {
    DONE: 'Done',
    PENDING: 'Pending'
};

export const CREDIT_CARD_PAYMENT_METHODS = {
    CYBERSOURCE: 'cybersource',
    ZEPZ: 'zepz'
};
